// Synchronous Build Digital brand blue
export const BRAND = {
  primary: "#0284c7",
  primaryMid: "#0369a1",
  primaryLight: "#e0f2fe",
  accent: "#38bdf8",
};
